import React from "react";

const Easypaisa = () => {
  return <div>Easypaisa</div>;
};

export default Easypaisa;
